module.exports = __webpack_public_path__ + "static/media/favicon.50c342c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/favicon.png
// module id = 186
// module chunks = 0